"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _Email = _interopRequireDefault(require("@material-ui/icons/Email"));

var _default = function _default(_ref) {
  var count = _ref.count;
  var displayCount = (0, _react.useMemo)(function () {
    if ((0, _isNil["default"])(count) || count < 2) return '';
    return count > 9 ? '9+' : count.toString();
  }, [count]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-white bg-primary p-3 rounded-full relative flex shadow-lg cursor-grabbing"
  }, displayCount && /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-6 h-6 shadow rounded-full absolute bg-white text-primary text-xs flex justify-center items-center font-semibold",
    style: {
      top: -5,
      right: -5
    }
  }, displayCount), /*#__PURE__*/_react["default"].createElement(_Email["default"], null));
};

exports["default"] = _default;
//# sourceMappingURL=index.js.map